enum ResponseMessage {
    Success = "success",
    InProgress = "inprogress",
    Failure = "failed",
    FailedWarning = "failed_warning",
    Redirect = "redirect",
    PermanentError = "permanent-error",
    ErrorUndisclosed = "error-undisclosed",
    Timeout = "timeout",
    Modal = "modal"
}

class Api {
    static readonly ResponseMessage = ResponseMessage;
}

enum LicensePlateType {
    Standard = "Standard",
    Special = "Special",
    Multi = "Multi",
    MultiSpecial = "MultiSpecial"
}

class Enums {
    static readonly LicensePlateType = LicensePlateType;
}

//App.Common.Constants
export class Constants {

    static readonly Api = Api;
    static readonly Enums = Enums;
}